module.exports = __webpack_public_path__ + "static/media/day10_favorites.8e6c0d87.gif";